// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__Id048"};